import { render, staticRenderFns } from "./Employee.html?vue&type=template&id=958beb7c&scoped=true&external"
import script from "./Employee.vue?vue&type=script&lang=js"
export * from "./Employee.vue?vue&type=script&lang=js"
import style0 from "./Employee.scss?vue&type=style&index=0&id=958beb7c&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "958beb7c",
  null
  
)

export default component.exports